import { defineStore } from 'pinia'

export interface TextMessageState {
  showFirstLine: boolean,
  showSecondLine: boolean,
  showThirdLine: boolean,
  firstLineText: string,
  firstLineTextType: number,
  secondLineTextType: number,
  secondLineLeftNumber: number,
  thirdLineText: string,
  showMessage: boolean,
  showType: number
}

const initialState = (): TextMessageState => ({
  showFirstLine: false,
  showSecondLine: false,
  showThirdLine: false,
  firstLineText: '',
  firstLineTextType: 0,
  secondLineTextType: 0,
  secondLineLeftNumber: 0,
  thirdLineText: '',
  showMessage: false,
  showType: 0
})

export const textMessageState = defineStore('textMessageState', {
  state: initialState,
})
